if (!window.cip_ActivateUsingSmsCodeDialog) {
    window.cip_ActivateUsingSmsCodeDialog = {};
}

(function () {
	"use strict";
	
	cip_ActivateUsingSmsCodeDialog.okText = "Activate";
	
	cip_ActivateUsingSmsCodeDialog.id = function () {
		return 'activateUsingSmsCodeDialog';
	};
	
	cip_ActivateUsingSmsCodeDialog.title = function () {
		return 'Enter SMS Activation Code';
	};
	
	cip_ActivateUsingSmsCodeDialog.width = function () {
		return 450;
	};

	cip_ActivateUsingSmsCodeDialog.content = function (data) {
		return 	'<p>A secure activation code has been sent to your mobile phone (' + data.maskedMobilePhoneNumber + ').</p>' +
				'<label id="activateUsingSmsCodeEmailLabel">' +
				  	'<span class="smsCodeLabel">Activation Code</span>' +
					'<input name="smsCode" class="form-control" type="text" style="width:150px" />' +
					'<em>*</em>' +
				'</label>';
	};	
	
	cip_ActivateUsingSmsCodeDialog.unpopulate = function (isNew) {
		var activateUsingSmsCode = {};
		
		activateUsingSmsCode.smsCode = $('#' + cip_ActivateUsingSmsCodeDialog.id() + " input[name=smsCode]").getValue();
		
		return activateUsingSmsCode;
	};
	
	cip_ActivateUsingSmsCodeDialog.populate = function (activateUsingSmsCode, isNew) {
		$('#' + cip_ActivateUsingSmsCodeDialog.id() + " input[name=smsCode]").setValue(activateUsingSmsCode.smsCode)
	};
}());